import { JetView } from "webix-jet"; // Importing JetView class from Webix Jet framework
import { devConfig, profile } from "config/config"; // Importing configuration and profile settings

/**
 * Class representing the FilterWatchListReportView.
 * Extends JetView to create a view for filtering the Watch List Report.
 */
export default class FilterWatchListReportView extends JetView { // Exporting the class that extends JetView
    config() { // Method defining the user interface layout
        const _ = this.app.getService("locale")._; // Getting localization function for translations

        const left = { // Left-side section that contains main filter controls
            margin: 5, // Outer margin for layout spacing
            rows: [ // Arranging child components vertically
                {
                    margin: 15, // Inner spacing between elements
                    css: "on-row", // Custom CSS for row styling
                    cols: [ // Elements arranged in columns
                        {
                            view: "text", // Text input component
                            name: "Datepicker", // Field name
                            id: "Datepicker", // Unique component ID
                            css: "reportrange", // Custom CSS class
                            readonly: true, // Field is read-only
                            label: "<span class='webix_icon icon-calendar'></span>" + _("Fecha de validación"), // Label with calendar icon
                            labelPosition: "top", // Label placed above input
                            placeholder: _("Click para seleccionar "), // Placeholder text
                        },
                        {
                            view: "datepicker", // Datepicker component for date selection
                            name: "Date", // Field name
                            id: "Date", // Unique ID
                            stringResult: true, // Return date as string
                            minWidth: 200, // Minimum width
                            label: "<span class='webix_icon icon-calendar'></span>" + _("Fecha de validación"), // Label with icon and translation
                            labelPosition: "top", // Label positioned at top
                            placeholder: _("Click para seleccionar "), // Placeholder for empty state
                            value: moment().format("YYYY-MM-DD"), // Default value set to today's date
                            format: "%d %M %Y", // Display date format
                            suggest: { // Dropdown calendar suggestion
                                type: "calendar", // Type of suggest view
                                body: {
                                    maxDate: new Date(), // Restrict to current date or earlier
                                },
                            },
                        },
                        {
                            view: "richselect", // Dropdown selection with search capability
                            name: "result", // Field name
                            id: "result", // Unique ID
                            label: _("Resultado"), // Localized label
                            labelPosition: "top", // Label above input
                            placeholder: _("Click para seleccionar"), // Placeholder text
                            options: [ // Dropdown options for filter results
                                { id: "all", value: _("Todos") }, // Option for all results
                                { id: "coincidence", value: _("Coincidencia") }, // Option for coincidence
                                { id: "no_coincidence", value: _("Sin coincidencia") }, // Option for no coincidence
                            ],
                        },
                        {
                            view: "text", // Text input for document number
                            name: "documentNumber", // Field name
                            id: "documentNumber", // Unique ID
                            label: "<span class='icon-doc'></span>" + _("Número de documento"), // Label with icon
                            labelPosition: "top", // Label at the top
                            placeholder: _("Ingrese número de documento"), // Placeholder text
                        },
                        {
                            view: "text", // Text input for user ID
                            name: "userId", // Field name
                            id: "userId", // Unique ID
                            type: "number", // Numeric input
                            css: "prm-filterByUser", // Custom CSS class
                            label: "<span class='icon-drivers-license-o'></span>" + _("ID Usuario"), // Label with icon and translation
                            labelPosition: "top", // Label positioned above field
                            placeholder: _("ID Usuario"), // Placeholder text
                        },
                    ],
                },
                {
                    margin: 15, // Vertical spacing
                    css: "on-row", // Row styling
                    cols: [ // Columns layout
                        {
                            view: "radio", // Radio button group for selecting view type
                            label: _("Tipo de vista"), // Localized label text
                            name: "Overall", // Field name
                            id: "Overall", // Unique ID
                            labelPosition: "top", // Label above component
                            options: [ // Radio button options
                                { id: 0, value: _("Detallada") }, // Option for detailed view
                                { id: 1, value: _("Resumida") }, // Option for summarized view
                            ],
                            value: 0, // Default selected value (detailed)
                            on: {
                                onChange: function (newVal) { // Event triggered when radio selection changes
                                    // Dynamic logic to show or hide filters based on selected view
                                    if (newVal == 1) { // If summarized view selected
                                        $$("result").hide(); // Hide result dropdown
                                        $$("documentNumber").hide(); // Hide document field
                                        $$("userId").hide(); // Hide user ID field
                                        $$("InactiveAutomaticRule").hide(); // Hide user ID field
                                    } else { // If detailed view selected
                                        $$("result").show(); // Show result dropdown
                                        $$("documentNumber").show(); // Show document field
                                        $$("userId").show(); // Show user ID field
                                        $$("InactiveAutomaticRule").show(); // Show user ID field
                                    }
                                },
                            },
                        },
                        {
                            view: "richselect", // Dropdown selection with search capability
                            name: "InactiveAutomaticRule", // Field name
                            id: "InactiveAutomaticRule", // Unique ID
                            label: _("Inactivo por regla automática"), // Localized label
                            labelPosition: "top", // Label above input
                            placeholder: _("Click para seleccionar"), // Placeholder text
                            hidden: !devConfig.getPermAction('InactiveAutomaticRule', 'Add'), // Permission check
                            options: [ // Dropdown options for filter InactiveAutomaticRules
                                { id: "0", value: _("Todos") }, // Option for all results
                                { id: "S", value: _("Si") }, // Option for coincidence
                                { id: "N", value: _("No") }, // Option for no coincidence
                            ],
                        },
                        {}, // Empty columns for spacing
                        {},
                    ],
                },
            ],
        };

        const upper_section = { // Section containing the filter fields
            css: "father-container", // CSS container class
            rows: [
                {
                    margin: 10, // Spacing around elements
                    cols: [left], // Include left section with filters
                },
            ],
        };

        const buttons = { // Buttons displayed in main filter view
            margin: 5, // Button area spacing
            cols: [
                {}, // Spacer
                {
                    view: "button", // Button component
                    value: _("Limpiar"), // Label "Clear" (translated)
                    autowidth: true, // Adjust width automatically
                    click: () => { // Clear button logic
                        this.getRoot().clear(); // Clear all form fields
                        $$("result").show(); // Reset visibility of filters
                        $$("documentNumber").show();
                        $$("userId").show();
                        $$("Overall").setValue(0); // Reset view type to detailed
                    },
                },
                {
                    view: "button", // Button component
                    value: _("Consultar"), // Label "Consult" (translated)
                    hotkey: "enter", // Activate with Enter key
                    type: "form", // Form-style button
                    autowidth: true, // Auto width
                    click: () => { // Event when clicking the "Consult" button
                        const filterdata = this.getRoot ? this.getRoot().getValues() : $$("myForm2").getValues(); // Get form values

                        let dateRange = $$("Datepicker").getValue(); // Get date range from datepicker

                        if (dateRange) { // If a date range is provided
                            if (typeof dateRange === "string" && dateRange.includes("-")) { // Case: date range string
                                const parts = dateRange.split(" - "); // Split start and end dates
                                const from = moment(parts[0], ["YYYY-MM-DD", "DD/MM/YYYY"]).format("YYYY-MM-DD"); // Format start date
                                const to = moment(parts[1], ["YYYY-MM-DD", "DD/MM/YYYY"]).format("YYYY-MM-DD"); // Format end date

                                filterdata["validationDateFrom"] = from; // Set start date
                                filterdata["validationDateTo"] = to; // Set end date
                            }
                            else if (typeof dateRange === "object" && dateRange.start && dateRange.end) { // Case: object with start and end
                                const from = moment(dateRange.start).format("YYYY-MM-DD"); // Format start date
                                const to = moment(dateRange.end).format("YYYY-MM-DD"); // Format end date
                                filterdata["validationDateFrom"] = from;
                                filterdata["validationDateTo"] = to;
                            }
                            else { // Case: single date selected
                                const single = moment(dateRange).format("YYYY-MM-DD");
                                filterdata["validationDateFrom"] = single;
                                filterdata["validationDateTo"] = single;
                            }
                        }

                        delete filterdata["Date"]; // Remove unused fields
                        delete filterdata["Datepicker"];

                        if ($$("Overall").getValue() == 1) { // If summarized view selected
                            delete filterdata["result"]; // Remove detailed filters
                            delete filterdata["documentNumber"];
                            delete filterdata["userId"];
                        }

                        this.app.callEvent("requests:filter", [filterdata]); // Trigger event with filter data
                        if ($$("filterPopup")) $$("filterPopup").hide(); // Close filter popup if open
                    },
                }
            ],
        };

        const buttons2 = { // Buttons for mobile popup version
            padding: 10, // Padding inside button area
            cols: [
                {
                    view: "button", // Clear button
                    value: _("Limpiar"),
                    autowidth: true,
                    click: () => {
                        $$("myForm2").clear(); // Clear mobile form fields
                        $$("result").show();
                        $$("documentNumber").show();
                        $$("userId").show();
                        $$("Overall").setValue(0);
                    },
                },
                {
                    view: "button", // Consult button
                    value: _("Consultar"),
                    type: "form",
                    autowidth: true,
                    click: () => {
                        const filterdata = this.getRoot ? this.getRoot().getValues() : $$("myForm2").getValues(); // Get form values

                        let dateRange = $$("Datepicker").getValue(); // Get date value

                        if (dateRange) { // Process date range as above
                            if (typeof dateRange === "string" && dateRange.includes("-")) {
                                const parts = dateRange.split(" - ");
                                const from = moment(parts[0], ["YYYY-MM-DD", "DD/MM/YYYY"]).format("YYYY-MM-DD");
                                const to = moment(parts[1], ["YYYY-MM-DD", "DD/MM/YYYY"]).format("YYYY-MM-DD");
                                filterdata["validationDateFrom"] = from;
                                filterdata["validationDateTo"] = to;
                            }
                            else if (typeof dateRange === "object" && dateRange.start && dateRange.end) {
                                const from = moment(dateRange.start).format("YYYY-MM-DD");
                                const to = moment(dateRange.end).format("YYYY-MM-DD");
                                filterdata["validationDateFrom"] = from;
                                filterdata["validationDateTo"] = to;
                            }
                            else {
                                const single = moment(dateRange).format("YYYY-MM-DD");
                                filterdata["validationDateFrom"] = single;
                                filterdata["validationDateTo"] = single;
                            }
                        }

                        delete filterdata["Date"];
                        delete filterdata["Datepicker"];

                        if ($$("Overall").getValue() == 1) {
                            delete filterdata["result"];
                            delete filterdata["documentNumber"];
                            delete filterdata["userId"];
                        }

                        this.app.callEvent("requests:filter", [filterdata]); // Trigger event
                        if ($$("filterPopup")) $$("filterPopup").hide(); // Hide popup
                    },
                }
            ],
        };


        const accordion_section2 = { // Accordion for desktop filters
            type: "wide", // Layout type
            rows: [
                {
                    multi: true,
                    view: "accordion", // Accordion container
                    css: "betShop", // Custom style
                    collapsed: true, // Initially collapsed
                    type: "clean", // Minimal visual style
                    rows: [
                        {
                            header: _("Filtros"), // Accordion title
                            id: "b5", // Unique ID
                            body: {
                                padding: 10, // Inner padding
                                rows: [upper_section, buttons], // Contains filters and buttons
                            },
                        },
                    ],
                },
            ],
        };

        const accordion_section3 = { // Scrollable section for mobile filters
            view: "scrollview",
            scroll: "xy", // Enable both scroll directions
            body: {
                padding: 10,
                rows: [upper_section], // Contain filter section
            },
        };

        const filterPopup = webix.ui({ // Popup window for filters (mobile)
            view: "window", // Window component
            move: true, // Allow moving window
            id: "filterPopup", // Unique ID
            fullscreen: true, // Display in fullscreen mode
            head: { // Window header
                view: "toolbar",
                cols: [
                    { view: "label", label: _("Filtros"), align: "center" }, // Popup title
                    {
                        view: "icon", // Close icon
                        icon: "wxi-close",
                        click: function () { // Close popup when clicked
                            this.getTopParentView().hide();
                        },
                    },
                ],
            },
            modal: true, // Disable background interaction
            position: "center", // Center the popup
            body: { // Popup body
                view: "form",
                id: "myForm2", // Form for mobile filters
                type: "clean", // Clean layout
                rows: [accordion_section3, buttons2], // Include scroll section and buttons
            },
        });

        return { // Return final configuration
            view: "form",
            type: "clean",
            id: "formFilterWatchList", // Form ID
            rows: [screen.width > 500 && screen.height > 500 ? accordion_section2 : { height: 1, width: 0 }], // Show desktop or mobile version based on screen size
        };
    }

    init() { // Called after view is rendered
        webix.ready(function () { // Run when Webix environment is ready
            if (profile.typeDate !== 2) { // Check date type from profile
                $$("Date").hide(); // Hide standard datepicker
                $$("Datepicker").show(); // Show range datepicker
            } else {
                $$("Date").show(); // Show normal datepicker
                $$("Datepicker").hide(); // Hide range datepicker
            }
        });

        const lang = this.app.getService("locale").getLang(); // Get current language
        $$("Datepicker").attachEvent("onAfterRender", function () { // Event after rendering datepicker
            devConfig.setDateModal(lang); // Apply localized date modal configuration
        });
    }
}
